import validateEmail from './lib/validateEmail.js';

class FFSBSubscribe {
	DOM: {
		form: HTMLFormElement;
		submitButton: HTMLButtonElement;
		spinner: HTMLDivElement;
		allInputs: NodeListOf<HTMLInputElement>;
		email: HTMLInputElement;
		dealerWrapper: HTMLDivElement | null;
		dealerCheckbox: HTMLInputElement | null;
	} = {} as any;
	state = {
		working: false,
		valid: false,
		error: false,
		success: false,
		emailIsValid: false,
	};

	constructor() {
		const form = document.querySelector('.js-sbSubscribeForm');
		if (!form) return;
		this.DOM = {
			form: form as HTMLFormElement,
			submitButton: form.querySelector('.js-submitButton') as HTMLButtonElement,
			spinner: form.querySelector('.js-spinner') as HTMLDivElement,
			allInputs: form.querySelectorAll('input, select'),
			email: form.querySelector('.js-customerEmail') as HTMLInputElement,
			dealerWrapper: form.querySelector('.js-dealerWrapper') as HTMLDivElement,
			dealerCheckbox: form.querySelector('#dealer') as HTMLInputElement,
		};
		this.handleQueryParams();
		this.events();
		this.render();
	}

	handleQueryParams() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('dealer') === '1' && this.DOM.dealerWrapper && this.DOM.dealerCheckbox) {
			this.DOM.dealerWrapper.classList.remove('js-hide');
			this.DOM.dealerCheckbox.checked = true;
		}
	}

	events() {
		this.DOM.form.addEventListener('submit', this.formSubmit.bind(this));
		this.DOM.form.addEventListener('keyup', this.formKeyUp.bind(this));
		for (let i = 0; i < this.DOM.allInputs.length; i++) {
			this.DOM.allInputs[i].addEventListener('input', this.globalInput.bind(this));
		}
	}

	formSubmit(e: SubmitEvent) {
		e.preventDefault();
		if (!this.validate() || this.state.working) return;
		this.state.working = true;
		this.render();
		const formData = new FormData(this.DOM.form);
		formData.append('action', 'sb_subscribe');
		const tags = formData.getAll('tag');
		if (formData.get('dealer')) {
			tags.push('TOPIC:DEALER');
		}
		formData.append('tag', tags.join(','));
		const newsletter = formData.get('newsletter');
		if (!newsletter) {
			formData.append('noSubscribe', 'true');
		}
		grecaptcha.ready(() => {
			grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then((token: string) => {
				formData.append('g-recaptcha-response', token);
				try {
					fetch(ajaxurl, {
						method: 'POST',
						body: formData,
					}).then(this.formResponse.bind(this));
				} catch (error: any) {
					console.log(error);
					this.showErrorMessage(error.message);
					window.scrollTo({ top: window.scrollY + 300, behavior: 'smooth' });
					this.state.working = false;
					this.render();
				}
			});
		});
	}

	async formResponse(res: Response) {
		this.state.working = false;
		await res.json();
		window.scrollTo({ top: window.scrollY + 300, behavior: 'smooth' });
		if (res.status === 200) {
			this.showSuccessMessage();
			this.state.success = true;
		} else {
			this.showErrorMessage(`Request could not be processed.`);
		}
		this.render();
	}

	formKeyUp() {
		this.validate();
		this.render();
	}

	globalInput() {
		this.validate();
		this.render();
	}

	render() {
		this.renderErrors();
		this.renderFooter();
	}

	renderErrors() {
		if (this.state.emailIsValid === false) {
			this.DOM.email.classList.add('js-error');
		} else {
			this.DOM.email.classList.remove('js-error');
		}
	}

	renderFooter() {
		if (this.state.valid && !this.state.working && !this.state.success) {
			this.DOM.submitButton.disabled = false;
		} else {
			this.DOM.submitButton.disabled = true;
		}
		if (this.state.working) {
			this.DOM.spinner.classList.remove('js-hide');
		} else {
			this.DOM.spinner.classList.add('js-hide');
		}
	}

	validate() {
		let valid = true;
		for (const input of this.DOM.allInputs) {
			if (!input.required || input.value) continue;
			valid = false;
		}

		if (this.DOM.email.value) {
			if (!validateEmail(this.DOM.email.value)) {
				valid = false;
				this.state.emailIsValid = false;
			} else {
				this.state.emailIsValid = true;
			}
		}

		this.state.valid = valid;
		return valid;
	}

	showSuccessMessage() {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'success');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Success!</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      <p>You&rsquo;ll now receive important service bulletins related to your equipment.</p>
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}

	showErrorMessage(message: string) {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'error');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Error</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      <p>Uh oh. There was an issue with the form submission:</p>
      ${message ? `<pre>${message}</pre>` : ''}
      <p><a href="mailto:support@freeflysystems.com">Email support</a> for help.</p>
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}
}
new FFSBSubscribe();
